import React, { Fragment, useCallback, useEffect, useState } from 'react'
import MonCompteHeader from '../MonCompteHeader'
import './VosAbonnements.css'
import { Magasin } from '../../../../Models/Magasin/MagasinModels'
import { useCookies } from 'react-cookie'
import { MagasinService } from '../../../../Services/Magasin/MagasinService'
import { Avatar, Collapse, Divider, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import dayjs from 'dayjs'
import { URL_MIDIS } from '../../../../Setting'

export function VosAbonnements(props: {
  setInterfaceMonCompte: any
  interfaceMonCompte: number
  magasins:Magasin[]
}) {

  const {interfaceMonCompte,magasins,setInterfaceMonCompte}=props;

  const[cookies] = useCookies(['token']);
  const[loading,setLoading]=useState(true);
  const token = cookies.token;

  //Automatisation récupération des données
  // const infosMagasins = useCallback(async ()=>{
  //   if(token){
  //     const result = await MagasinService().getMagasinsForVosAbonnements(token);
  //     if(result && (result.status===200||result.status===201)){
  //       setMagasins(result.data);
  //       setLoading(false)
  //     }
      
  //   }
  // },[token])
  
  // useEffect(()=>{
  //   if(loading)
  //     infosMagasins();
  // },[infosMagasins, loading]);

  //gestion nested list
  interface InitialStateI {
    [key: number]: boolean;
  }
  const [selectedMagasins, setSelectedIndex] = useState<number>();
  const magasinState:InitialStateI = Object.fromEntries(magasins.map((value)=>([value.id, false])));
  const [openMagasin, setOpenMagasin] = useState(magasinState);

  const handleClick = (index: number) => {
    setSelectedIndex(index);
    setOpenMagasin((o)=>({ ...magasinState, [index]: !o[index] }));
  };

  return (
    <div className='VosAbonnements'>
      <MonCompteHeader
        setInterfaceMonCompte={setInterfaceMonCompte}
        interfaceMonCompte={interfaceMonCompte}
        mainText='Vos abonnements'
        subText='Voir le détail de vos abonnements, soldes de messages'
      />
      <div className='VosAbonnements-main-body'>
        <div className='VosAbonnements-body'>
          <List sx={{ width: '90%' }}>
            {
              magasins.map((magasin, index)=>(
                <Fragment key={index}>
                  <ListItemButton 
                    alignItems="center" 
                    onClick={()=>{handleClick(magasin.id)}}
                    selected={selectedMagasins===magasin.id}
                    sx={{justifyContent:'space-between'}}
                  >
                    <ListItemAvatar sx={{maxWidth:'12%'}}>
                      <Avatar sx={{width:'100%', height:'unset'}} variant='square' alt='logo' src={magasin.typeMagasin && magasin.typeMagasin.fichiers.length>0 ? `${URL_MIDIS+magasin.typeMagasin.fichiers[0].chemin}` : ''}/>
                    </ListItemAvatar>
                    <ListItemText
                      className='nomMagasin'
                      primary={magasin.nom.toUpperCase()}
                      sx={{ml:2}}
                    >
                    </ListItemText>
                    {openMagasin[magasin.id] ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                  <Collapse in={openMagasin[magasin.id]} timeout="auto" unmountOnExit>
                      {
                        magasin.abonnements?.map((abonnement, index)=>(
                          <ListItem key={index}>
                            <div className='VosAbonnements-text'>
                              {/* <p className='bold-text'>Mon abonnement</p> */}
                              <p>
                                Pack : <span className='colored-text'>{abonnement.pack?.nom}</span>
                                {/* Pack : <span className='colored-text'>{magasin?.abonnements[0].pack?.nom}</span> */}
                              </p>
                              <p>
                                Date anniversaire : <span className='colored-text'>{dayjs(abonnement.souscription).format('DD/MM')}</span>
                              </p>
                              {
                               (abonnement.optionsAbonnement && abonnement.optionsAbonnement.length>0)&&
                               <Fragment>
                                {
                                  abonnement.optionsAbonnement.map((_option, index)=>(
                                    <Fragment key={index}>
                                      <p>
                                        {_option.typesMessage.find(type=>type.type==='Galec') ? "Nombre de spot Galec par an" : "Nombre de spot express par an"} par an :
                                        <span className='colored-text'>{_option.quota ?? 0}</span>
                                      </p>
                                    </Fragment>
                                  ))
                                }
                               </Fragment>
                              }
                              <p> Nombre de flux : <span className='colored-text'>{abonnement.fluxes.length}</span></p>
                              {
                                (abonnement.fluxes.length>1)&&
                                <Fragment>
                                  {
                                    abonnement.fluxes.map((flux,index)=>(
                                      <Fragment key={index}>
                                        <p>Flux n°{index+1} : <span className='colored-text'>{flux.nom}</span></p>
                                      </Fragment>
                                    ))
                                  }
                                </Fragment>
                              }
                              {
                               (abonnement.optionsAbonnement && abonnement.optionsAbonnement.length>0)&&
                               <Fragment>
                                <br/>
                                <p>
                                  <strong><span className='colored-text'>Mon solde de message :</span></strong>
                                </p>
                                {
                                  abonnement.optionsAbonnement.map((_option, index)=>(
                                    <Fragment key={index}>
                                      <p>
                                        {_option.typesMessage.find(type=>type.type==='Galec') ? "Spot Galec" : "Spot express"} :
                                        <span className='colored-text'>{_option.quota - _option.utilise >0 ? _option.quota - _option.utilise : 0}</span>
                                      </p>
                                    </Fragment>
                                  ))
                                }
                               </Fragment>
                              }
                            </div>
                          </ListItem>
                        ))
                      }
                  </Collapse>
                  <Divider component="li" variant="middle"/>
                </Fragment>
              ))
            }
          </List>
          {/* <div className='VosAbonnements-image'>
            <img
              src={`${process.env.PUBLIC_URL}/img/leclerc.svg`} //trouver un moyen de pouvoir avoir des images propres aux magasins
              alt={'E.Leclerc'}
            />
          </div> */}
        </div>
      </div>
    </div>
  )
}